import React from 'react';
import Immutable from 'immutable';
import { parseSearchRuntime } from '../../data/runtimeutils';
import PSInput from './psinput';
import { triggerActionEvent } from './common';

const EMPTY_MAP = Immutable.Map({});

export default class SearchRuntimeInput extends React.PureComponent {
	constructor() {
		super();
		this.state = {
			text: ''
		};
		this.onChange = this.onChange.bind(this);
		this.processText = this.processText.bind(this);
	}

	processText() {
		this.onChange(parseSearchRuntime(this.state.text));

	}

	onChange(value) {
		const onChange = this.props.onChange;
		if (typeof onChange === 'function') {
			onChange(value);
		}
	}


	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.value === nextProps.value) {
			return null;
		}
		return {
			text: (nextProps.value || EMPTY_MAP).get('text'),
			value: nextProps.value
		};
	}


	render() {
		const value = this.props.value || EMPTY_MAP;
		let style = {};
		if (this.props.width) {
			style.width = this.props.width;
		}
		return (
			<PSInput
				data-name={this.props.name}
				className={'ps-input searchRuntime' + (this.props.readOnly ? ' readonly' : '')}
				data-autofocusid={this.props.autoFocusId}
				placeholder={this.props.placeholder}
				value={this.state.text || ''}
				style={style}
				onChange={(e) => {
					this.setState({
						text: e.target.value
					});
				}}
				onKeyDown={(e) => {
					if (e.keyCode === 13) {
						this.processText();
						triggerActionEvent(e.target);
					}
				}}
				spellCheck="false"
				autoComplete="off"
				name={this.props.name}
				readOnly={this.props.readOnly}
				onBlur={this.processText}
			/>
		);

	}
}

